export default class TransactionRequest {
    constructor(data) {
        this.children = data.children;
        this.description = data.description;
        this.descriptionAnnotated = data.descriptionAnnotated;
        this.data = data.data;
        this.from = data.from;
        this.to = data.to;
    }
}
//# sourceMappingURL=TransactionRequest.js.map